<template lang="pug">
  .brief-info(v-loading="loading")
    title-bar {{ $t('公司信息') }}
    campaign-info(
      :data="basicInfo.company_information"
    )
    title-bar {{ $t('联系人信息') }}
    contact-info(
      v-if="basicInfo"
      :data="basicInfo.user"
    )
    title-bar {{ $t('经验&奖项') }}
    experience-and-awards(
      v-if="basicInfo && experienceInfo"
      :experienceInfo="experienceInfo"
      :data="basicInfo.experience_award"
    )
    title-bar {{ $t('项目类别') }}
    category(
      :data="basicInfo.category_scope"
    )
</template>

<script>
import TitleBar from '@/components/TitleBar'
import CampaignInfo from './components/CampaignInfo'
import ContactInfo from './components/ContactInfo'
import ExperienceAndAwards from './components/ExperienceAndAwards'
import Category from './components/Category'
import axios from 'axios'

export default {
  components: {
    TitleBar,
    CampaignInfo,
    ContactInfo,
    ExperienceAndAwards,
    Category
  },
  data () {
    return {
      basicInfo: {
        company_introduction: {},
        category_scope: []
      },
      experienceInfo: null,
      loading: false
    }
  },
  computed: {
    vendorId () {
      return this.$store.state.vendor.id
    }
  },
  mounted () {
    this.fetchBasicInfo()
    this.fetchExperienceInfo()
  },
  methods: {
    fetchBasicInfo () {
      this.loading = true
      axios
        .get('/vendor/vendor/getBasicInfo', {
          params: {
            vendor_id: this.vendorId
          }
        })
        .then(res => {
          this.basicInfo = res
          this.loading = false
        })
    },
    fetchExperienceInfo () {
      this.loading = true
      axios
        .get('/vendor/vendor/getVendorExperience', {
          params: {
            vendor_id: this.vendorId
          }
        })
        .then(res => {
          this.experienceInfo = res
          this.loading = false
        })
    }
  }
}
</script>
